import type { MailboxInfo } from "owa-client-types";
import { mutatorAction } from "satcheljs";
import type { AccountConfiguration } from "../store/schema/OwaSessionStore";
import { getAccountSettingsInternal } from "../utils/getAccountSettingsInternal";

export function updateAccountScopeUserSettings(mailboxInfo: MailboxInfo, updateFunction: (accountScopeUserSettings: AccountConfiguration) => void, skipMutator?: boolean): void {
    (skipMutator ? updateAccountScopeUserSettingsInner : updateAccountScopeUserSettingsMutator)(mailboxInfo, updateFunction);
}

export const updateAccountScopeUserSettingsMutator: typeof updateAccountScopeUserSettingsInner = mutatorAction("updateAccountScopeUserSettings", updateAccountScopeUserSettingsInner);

export function updateAccountScopeUserSettingsInner(mailboxInfo: MailboxInfo, updateFunction: (accountScopeUserSettings: AccountConfiguration) => void): void {
    const settings = getAccountSettingsInternal(mailboxInfo);
    if (settings) {
        updateFunction(settings);
    }
}
